(function () {
  'use strict';

  var MSG_ES = {
    generic:
      'No hemos podido verificar tu pedido con estos datos. Asegúrate de usar el mismo email con el que recibiste la confirmación del pedido. Si el problema persiste, escríbenos a support@zucchiini.com.',
    tooRecent:
      'Tu pedido es muy reciente. El ajuste de talla se procesa una vez que tu pedido lleva al menos 3 días desde la compra. Vuelve a intentarlo en cuanto pase ese plazo. Si ya tienes el pedido en mano y necesitas ayuda urgente, escríbenos a support@zucchiini.com.',
    tooOld:
      'El plazo para solicitar el ajuste de talla es de 45 días desde la compra y tu pedido ya supera ese plazo. Si crees que es un error o quieres exponernos tu caso, escríbenos a support@zucchiini.com.',
    notFulfilledYet:
      'Tu pedido aún no ha salido de almacén. Recibirás un email cuando se envíe — vuelve a intentar el ajuste de talla cuando lo tengas en casa.',
    rateLimit:
      'Has realizado demasiados intentos. Prueba de nuevo en unos minutos.',
    alreadyUsed:
      'Este pedido ya fue procesado recientemente. Revisa tu email — te hemos enviado las siguientes instrucciones. Si no las encuentras, contacta con support@zucchiini.com.',
    success: 'Pedido verificado. Continuando...',
    invalidEmail: 'Introduce un email válido.',
    invalidOrder: 'El número de pedido debe contener entre 3 y 10 dígitos.',
    verifyingLabel: 'Verificando',
    verifyLabel: 'Verificar pedido',
  };

  var MSG_EN = {
    generic:
      'We could not verify your order with these details. Make sure you use the same email you received the order confirmation with. If the issue persists, contact us at support@zucchiini.com.',
    tooRecent:
      'Your order is too recent. The size adjustment is processed once your order is at least 3 days old. Please try again after that. If you already have your order in hand and need urgent help, contact us at support@zucchiini.com.',
    tooOld:
      'The size adjustment request window is 45 days from purchase and your order is past that. If you think this is a mistake or want to explain your case, contact us at support@zucchiini.com.',
    notFulfilledYet:
      'Your order has not yet shipped. You will receive an email when it does — please request the size adjustment once you have received it.',
    rateLimit:
      'Too many attempts. Please try again in a few minutes.',
    alreadyUsed:
      'This order has already been processed recently. Please check your email — we have sent you the next instructions. If you cannot find them, contact us at support@zucchiini.com.',
    success: 'Order verified. Redirecting...',
    invalidEmail: 'Please enter a valid email.',
    invalidOrder: 'The order number must contain between 3 and 10 digits.',
    verifyingLabel: 'Verifying',
    verifyLabel: 'Verify order',
  };

  function getMessages() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('en') === 0) return MSG_EN;
    return MSG_ES;
  }

  var EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var ORDER_RX = /^\d{3,10}$/;

  function init() {
    var form = document.getElementById('ajuste-talla-form');
    if (!form) return;

    var MSG = getMessages();
    var emailInput = form.querySelector('#at-email');
    var orderInput = form.querySelector('#at-order');
    var submitBtn = form.querySelector('#at-submit');
    var submitLabel = form.querySelector('.ajuste-talla__submit-label');
    var messageBox = form.querySelector('#at-message');
    var workerUrl = form.getAttribute('data-worker-url');
    var confirmUrl = form.getAttribute('data-confirm-url') || '/pages/ajuste-de-talla-confirmado';

    function showMessage(text, variant) {
      messageBox.textContent = text;
      messageBox.className =
        'ajuste-talla__message' +
        (variant === 'success' ? ' ajuste-talla__message--success' : '');
    }

    function clearMessage() {
      messageBox.textContent = '';
      messageBox.className = 'ajuste-talla__message';
    }

    function setInvalid(input, invalid) {
      if (invalid) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }

    function setLoading(loading) {
      submitBtn.disabled = loading;
      if (loading) {
        submitLabel.textContent = MSG.verifyingLabel;
        if (!submitBtn.querySelector('.ajuste-talla__spinner')) {
          var s = document.createElement('span');
          s.className = 'ajuste-talla__spinner';
          s.setAttribute('aria-hidden', 'true');
          submitBtn.appendChild(s);
        }
      } else {
        submitLabel.textContent = MSG.verifyLabel;
        var spin = submitBtn.querySelector('.ajuste-talla__spinner');
        if (spin) spin.remove();
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearMessage();

      var email = (emailInput.value || '').trim().toLowerCase();
      var order = (orderInput.value || '').trim().replace(/^#/, '');

      setInvalid(emailInput, false);
      setInvalid(orderInput, false);

      if (!EMAIL_RX.test(email)) {
        setInvalid(emailInput, true);
        showMessage(MSG.invalidEmail);
        emailInput.focus();
        return;
      }
      if (!ORDER_RX.test(order)) {
        setInvalid(orderInput, true);
        showMessage(MSG.invalidOrder);
        orderInput.focus();
        return;
      }

      if (!workerUrl || workerUrl.indexOf('TU-CUENTA') !== -1) {
        showMessage(MSG.generic);
        return;
      }

      setLoading(true);

      fetch(workerUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, order_number: order }),
      })
        .then(function (res) {
          return res.json().then(function (body) {
            return { status: res.status, body: body };
          });
        })
        .then(function (r) {
          if (r.status === 200 && r.body && r.body.token) {
            try {
              sessionStorage.setItem('ajuste-talla-token', r.body.token);
            } catch (e) {}
            showMessage(MSG.success, 'success');
            window.location.href = confirmUrl;
            return;
          }
          var reasonToMsg = {
            too_recent: MSG.tooRecent,
            too_old: MSG.tooOld,
            not_fulfilled_yet: MSG.notFulfilledYet,
          };
          if (r.status === 429) {
            showMessage(MSG.rateLimit);
          } else if (r.status === 404 && r.body && r.body.error === 'already_used') {
            showMessage(MSG.alreadyUsed);
          } else if (
            r.status === 404 &&
            r.body &&
            r.body.error === 'not_found' &&
            reasonToMsg[r.body.reason]
          ) {
            showMessage(reasonToMsg[r.body.reason]);
          } else {
            showMessage(MSG.generic);
          }
          setLoading(false);
        })
        .catch(function () {
          showMessage(MSG.generic);
          setLoading(false);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
